export default {
    /**
     * @func message
     * @desc When a WebSocket message is received.
     */
    message(state, message) {
        // console.log('user', message)
    },

    setUser(state, user) {
        state.user = user
    }
}
